import * as d3 from 'd3';
import * as moment from 'moment';

import { BatchResult, DateStepResult } from '../../models';
import { momentFormat } from '../../common/constants';
import { DurationFormatter } from './durationFormatter';
import { taskResultsScale } from '../../common/scales';

export class Tooltip {
    private readonly _selection: d3.Selection<BatchResult>;
    // private _colorScale: d3.scale.Ordinal<TaskStatus, string>;
    private _stepHeight = 15;
    private _height: number;
    private _width = 260;
    private _color: (d: DateStepResult) => string;
    private _format:(d: DateStepResult) => string;

    constructor(container: d3.Selection<any>) {
        this._selection = container.append('g')
            .classed('info', true)
            .style('visibility', 'hidden');
        this._selection.append('rect')
            .attr('width', this._width)
            .attr('height', 50)
            .style('stroke', '#999')
            .style('fill', 'rgba(255,255,255,0.7)');
        this._selection.append('text')
            .attr('x', 5)
            .attr('y', 10)
            .classed('dates', true);
        this._selection.append('g')
            .attr('transform', `translate(${5},${15})`)
            .classed('steps', true);
        this._color = d => taskResultsScale(d.exitCode);
        this._format = sr => `${sr.stepName} (${DurationFormatter.formatDuration(moment.duration(sr.elapsed))})`;
    }


    color(): (d: DateStepResult) => string;
    color(value: (d: DateStepResult) => string): this;
    color(value?: (d: DateStepResult) => string): this | ((d: DateStepResult) => string) {
        if (arguments.length) {
            this._color = value;
            return this;
        }
        return this._color;
    }

    format(): (d: DateStepResult) => string;
    format(value: (d: DateStepResult) => string): this;
    format(value?: (d: DateStepResult) => string): this | ((d: DateStepResult) => string) {
        if (arguments.length) {
            this._format = value;
            return this;
        }
        return this._format;
    }

    show() {
        this._selection.style('visibility', 'visible');
        return this;
    }

    hide() {
        this._selection.style('visibility', 'hidden');
        return this;
    }

    translateX(): number {
        const translate = d3.transform(this._selection.attr('transform')).translate;
        return translate[0];
    }

    translateY(): number {
        const translate = d3.transform(this._selection.attr('transform')).translate;
        return translate[1];
    }

    move(translateX: number, translateY: number): this {
        this._selection
            .attr('transform', `translate(${translateX},${translateY})`);
        return this;
    }

    height(): number {
        return this._height;
    }

    width(): number {
        return this._width;
    }

    update(d: BatchResult) {
        this._height = (d.stepResults.length + 1) * this._stepHeight;
        this._selection.select('rect')
            .attr('height', this._height);
        this._selection.select('.dates')
            .text(moment(d.range.beginDateTime)
                .format(momentFormat) + ' - ' + moment(d.range.endDateTime)
                    .format(momentFormat));

        const db = this._selection.select('.steps')
            .selectAll('.step-result')
            .data(d.stepResults);
        db.exit().remove();
        const es = db.enter()
            .append('g')
            .classed('step-result', true)
            .attr('transform', (dd, ii) => `translate(${0},${ii * this._stepHeight})`);
        es.append('text')
            .attr('y', 10);
        db.select('text')
            .style('fill', sr => this._color(sr))
            .text(this._format);
    }
}